var _style, _defs, _defs2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconXbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{clip-path:url(#SVGID_4_);fill:#83858C;}\n\t.st3{fill:none;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M11,21.96c-1.54-0.15-3.1-0.7-4.44-1.57c-1.12-0.73-1.38-1.03-1.38-1.63c0-1.21,1.33-3.32,3.6-5.73 c1.29-1.37,3.09-2.97,3.28-2.93c0.38,0.08,3.4,3.03,4.53,4.41c1.79,2.19,2.61,3.99,2.19,4.79c-0.32,0.61-2.29,1.8-3.73,2.25 C13.86,21.92,12.29,22.08,11,21.96z M3.67,17.5c-0.93-1.43-1.4-2.84-1.63-4.88c-0.08-0.67-0.05-1.06,0.17-2.44 c0.27-1.72,1.25-3.71,2.43-4.93c0.5-0.52,0.55-0.53,1.16-0.33c0.74,0.25,1.53,0.8,2.76,1.91l0.72,0.65L8.89,7.96 c-1.82,2.23-3.74,5.4-4.46,7.36c-0.39,1.06-0.55,2.13-0.38,2.58C4.16,18.2,4.05,18.08,3.67,17.5L3.67,17.5z M20.05,17.74 c0.09-0.45-0.02-1.28-0.3-2.11c-0.59-1.8-2.57-5.16-4.39-7.44l-0.57-0.72l0.62-0.57c0.81-0.74,1.37-1.18,1.97-1.56 c0.48-0.3,1.16-0.56,1.45-0.56c0.18,0,0.82,0.66,1.33,1.38c0.8,1.12,1.38,2.47,1.68,3.88c0.19,0.91,0.21,2.86,0.03,3.77 c-0.15,0.75-0.45,1.71-0.75,2.37c-0.23,0.49-0.78,1.44-1.03,1.75C19.98,18.09,19.98,18.09,20.05,17.74L20.05,17.74z M11.17,4.44 c-0.84-0.43-2.13-0.88-2.85-1C8.07,3.39,7.65,3.37,7.37,3.38c-0.59,0.03-0.56,0,0.38-0.45c0.79-0.37,1.44-0.59,2.33-0.78 c1-0.21,2.88-0.21,3.87-0.01c1.06,0.22,2.32,0.69,3.02,1.12l0.21,0.13l-0.48-0.02c-0.96-0.05-2.35,0.34-3.85,1.07 c-0.45,0.22-0.84,0.39-0.87,0.39C11.96,4.83,11.59,4.65,11.17,4.44L11.17,4.44z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: -3,
    className: "st2",
    width: 30,
    height: 30
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    className: "st3",
    width: 22,
    height: 22
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXbox);
export default __webpack_public_path__ + "static/media/icon-xbox.9e14ee9d5d502c5d6c7bb3eadfb6f116.svg";
export { ForwardRef as ReactComponent };